var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('edit-sme-kyc',{attrs:{"is-create":"","is-fina":_vm.isFina,"form":_vm.form}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }